import notification from "antd/es/notification";
import { getNotificationDisplayTime } from "@shared/utils/misc";
import { NotificationInstance } from "antd/es/notification/interface";
import { useSelector } from "react-redux";
import { selectIsDarkMode } from "@shared/slices/common.slice";
import { useRefValue } from "@shared/utils/hooks/misc";

const useNotification = (): [NotificationInstance, any] => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const isDarkMode = useSelector(selectIsDarkMode);
  const isDarkModeRef = useRefValue(isDarkMode);

  const notificationOpen = notificationApi.open;

  notificationApi.open = (props) => {
    const duration =
      props.duration !== undefined
        ? props.duration
        : typeof props.description === "string"
        ? getNotificationDisplayTime(props.description, true)
        : 8;

    return notificationOpen({
      ...props,
      duration,
      className: isDarkModeRef.current
        ? `${props.className} dark-mode`
        : props.className,
    });
  };

  return [notificationApi, contextHolder];
};

export default useNotification;
